// // // admin-frontend/src/api/blogApi.js
// import axios from 'axios';
// // const API_BASE_URL = 'https://japl-backend.onrender.com/api/blogs'; // Your backend API base URL
// const API_BASE_URL = 'https://japl-backend-8xvt.onrender.com/api/blogs';
// // const API_BASE_URL = "http://localhost:5000/api/blogs";
// // NOTE: In a real app, you'd send an Authorization header with a token
// // const config = (token) => ({
// //   headers: {
// //     'Content-Type': 'application/json',
// //     'Authorization': `Bearer ${token}`
// //   }
// // });

import api from "./api";

export const uploadCoverImage = async (file) => {
  const formData = new FormData();
  formData.append("cover", file);

  const res = await api.post(`/uploads/cover`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  return res.data; // { url, mediaType }
};

export const getAllBlogs = async () => {
  try {
    const response = await api.get('/blogs');
    return response.data;
  } catch (error) {
    console.error('Error fetching blogs for admin:', error);
    throw error;
  }
};

export const createBlog = async (blogData) => {
  try {
    const response = await api.post('/blogs', blogData); 
    return response.data;
  } catch (error) {
    console.error('Error creating blog:', error);
    throw error;
  }
};

export const updateBlog = async (id, blogData) => {
  try {
    const response = await api.put(`/blogs/${id}`, blogData);
    return response.data;
  } catch (error) {
    console.error(`Error updating blog with ID ${id}:`, error);
    throw error;
  }
};

export const deleteBlog = async (id) => {
  try {
    const response = await api.delete(`/blogs/${id}`); 
    return response.data;
  } catch (error) {
    console.error(`Error deleting blog with ID ${id}:`, error);
    throw error;
  }
};
